import * as t from 'io-ts';

import {RAccountIdRef, RCardIdRef, RConversationIdRef} from '../../../models/api/apiTypes';
import {RAsyncStatus} from '../../appTypes';
import {RPanelCancelTokenId} from '../panelCancelTokenId';
import {PanelTypesEnum, RAccountDetailsPanelId, RPanelStateBase} from '../panelStateBase';

/*
 * Runtime types.
 */

const RAccountDetailsCardsState = t.type({
  loadingStatus: RAsyncStatus,
  cardIds: t.union([t.undefined, t.readonlyArray(RCardIdRef)]),
});

export const RAccountDetailsState = t.readonly(
  t.intersection([
    t.type({
      accountId: t.union([t.undefined, RAccountIdRef]),
      status: RAsyncStatus,
      cardsState: t.union([t.undefined, RAccountDetailsCardsState]),
    }),
    t.partial({
      conversationStatus: RAsyncStatus,
      conversationIds: t.array(RConversationIdRef),
      hasMoreConversations: t.boolean,
    }),
  ]),
);

export const RAccountDetailsPanelStateDirty = t.intersection([
  RPanelStateBase,
  RAccountDetailsState,
  t.type({
    id: RAccountDetailsPanelId,
    cancelTokenId: RPanelCancelTokenId,
    type: t.literal(PanelTypesEnum.ACCOUNT_DETAILS),
  }),
  t.partial({
    popupWidth: t.number,
  }),
]);

/*
 * Types.
 */

export interface AccountDetailsPanelState extends Readonly<t.TypeOf<typeof RAccountDetailsPanelStateDirty>> {}
export const RAccountDetailsPanelState = t.clean<AccountDetailsPanelState>(
  RAccountDetailsPanelStateDirty as any,
);
export interface AccountDetailsCardsState extends Readonly<t.TypeOf<typeof RAccountDetailsCardsState>> {}
